export function initFolders() {
  return {
    list() {
      return Promise.resolve({
        data: []
      });
    }
  };
}